import './App.css';
import Home from './pages/Home/Home';
import EngineeringExperts from './pages/Aboutus/AboutSection';
import FooterSection from './pages/Footer/FooterSection';
import EngineeringCompany from './pages/Company/company';
import AboutCompany from './pages/AboutCompany/AboutCompany';
import Navbar from './components/Navbar/Navbar';
import { ToastContainer } from "react-toastify";
import EttiksoftChronicles from './pages/EttiksoftChronicles/EttiksoftChronicles';
import Testimonials from './pages/Testimonials/Testimonials';
function App() {
  return (
    <div className="App">
      <Navbar/>
      <ToastContainer />
      <Home />
      <EngineeringCompany/>
      <AboutCompany/>
      <EngineeringExperts/>
      <EttiksoftChronicles/>
      <Testimonials/>
      <FooterSection/>
    </div>
  );
}

export default App;
